import React, { useContext, useState, useEffect } from 'react'
import City from './city'
import { useCityName } from './hooks'

export interface ICityPickerProps {
  onChange?: (value: string) => void
}

export default function CityPicker({ onChange }: ICityPickerProps) {
  const [visible, setVisible] = useState(false)
  const cityName = useCityName()
  const togglePicker = (e: any) => {
    if (e !== undefined && typeof e !== 'string') {
      e.stopPropagation()
    }
    setVisible(!visible)
    typeof e === 'string' && cityName !== e && onChange && onChange(e)
  }
  return (
    <div className="city-picker" onClick={togglePicker}>
      <div className="city-picker-input">{cityName}</div>
      <span className="icon-up-arrow-ic" />
      {visible && <City onChange={togglePicker} />}
      <style jsx>
        {`
          .city-picker {
            position: relative;
            width: 100%;
            height: 36px;
            line-height: 36px;
            padding-left: 12px;
            border-radius: 4px;
            border: solid 1px #ededed;
            cursor: pointer;
          }
          .city-picker :global(> section) {
            top: 40px;
          }
          .icon-up-arrow-ic {
            position: absolute;
            right: 7px;
            top: 50%;
            margin-top: -7px;
            transform: rotate(180deg);
          }
        `}
      </style>
    </div>
  )
}
